import { ArrowRight } from "@mui/icons-material";
import { Popover } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import FeedbackIcon from "../../assets/images/icons/FeedbackIcon.tsx";
import MailIcon from "../../assets/images/icons/MailIcon.tsx";
import { StyledMenuItem } from "../../components/common/BriaDropDown/BriaDropDown.tsx";
import GeneralFeedbackPopup from "../../components/common/GeneralFeedback/GeneralFeedbackPopup.tsx";
import LinkConstants from "../../constants/LinkConstants.ts";
import styles from "./Sidebar.module.scss";
import SidebarButton from "./SidebarButton.tsx";

const GetHelpButton = () => {
	const { t } = useTranslation("translation", { keyPrefix: "sideMenu" });
	const [anchorEl, setAnchorEl] = useState<SVGSVGElement>();
	const [openFeedback, setOpenFeedback] = useState(false);

	const handleOpenPopover = (event: React.MouseEvent<SVGSVGElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClosePopover = () => {
		setAnchorEl(undefined);
	};

	const handleOpenFeedback = () => {
		setOpenFeedback(true);
	};

	const handleCloseFeedback = () => {
		setOpenFeedback(false);
	};

	return (
		<>
			<SidebarButton
				onClick={handleOpenPopover}
				title={t("getHelp")}
				iconStart={MailIcon}
				iconEnd={ArrowRight as any}
				selected={!!anchorEl}
				fullWidth={false}
			/>
			<Popover
				open={!!anchorEl}
				onClose={handleClosePopover}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "center",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "center",
					horizontal: "left",
				}}
				slotProps={{ paper: { className: styles.popover } }}
			>
				{/*<StyledMenuItem className={styles.popoverItem} onClick={() => window.open(LinkConstants.STATUS_PAGE)}>*/}
				{/*	<NotesIcon />*/}
				{/*	{t("statusPage")}*/}
				{/*	<OpenInNew />*/}
				{/*</StyledMenuItem>*/}
				<StyledMenuItem
					className={styles.popoverItem}
					onClick={() => window.open(LinkConstants.CONTACT_US_FORM_LINK)}
				>
					<MailIcon />
					{t("contactUs")}
				</StyledMenuItem>
				<StyledMenuItem className={styles.popoverItem} onClick={handleOpenFeedback}>
					<FeedbackIcon />
					{t("feedback")}
				</StyledMenuItem>
				{openFeedback && <GeneralFeedbackPopup open={openFeedback} onClose={handleCloseFeedback} />}
			</Popover>
		</>
	);
};

export default observer(GetHelpButton);
